import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useDictionary } from '@/shared/lib/i18n';
import { toast } from '@/shared/lib/toast';
import { QueryKey } from '@/types/query';
import { RejectCandidateParams } from '../model';
import { recruiterRejectsCandidateClient } from './client';

export const useRejectCandidateMutation = () => {
  const dictionary = useDictionary();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QueryKey.useRejectCandidateMutation],
    mutationFn: async ({ esPersonId, campaignId, reason, improvedJobId }: RejectCandidateParams) => {
      await recruiterRejectsCandidateClient.rejectAppliedCandidate(esPersonId, campaignId, improvedJobId);
      await recruiterRejectsCandidateClient.addCandidateNote(esPersonId, { content: reason, campaign: campaignId });
      await recruiterRejectsCandidateClient.hideCandidate(esPersonId, campaignId);
    },
    onSuccess: () => {
      toast.success(dictionary.candidateRejectedSuccessfully);
      queryClient.removeQueries([QueryKey.useBestMatchesInfiniteQuery], { exact: false });
      queryClient.removeQueries([QueryKey.useRatedCandidatesQuery], { exact: false });
      queryClient.removeQueries([QueryKey.useRatedCandidatesStats], { exact: false });
      queryClient.invalidateQueries([QueryKey.useCandidateHistoryQuery], { exact: false });
    },
    onError: () => {
      toast.error(dictionary.somethingWentWrong);
    },
  });
};
